module.exports = __webpack_public_path__ + "img/event-image.2ce0f636.png";